
const html_header = `
    <html>
        <head>
        <link href="https://cdn.quilljs.com/1.3.7/quill.snow.css" rel="stylesheet">
        <style>
            .ql-editor {
                padding-top: 0px; /* or whatever value you want */
            }
            .ql-editor .ql-indent-1 { margin-left: 1em; }
            .ql-editor .ql-indent-2 { margin-left: 2em; }
            .ql-editor .ql-indent-3 { margin-left: 3em; }
            .ql-editor .ql-indent-4 { margin-left: 4em; }
            .ql-editor .ql-indent-5 { margin-left: 5em; }
            .text-center {
            text-align: center;
            }
            .white-text {
            color: white;
            }
            .sign-table td {
            font-size: 12px;
            vertical-align: top;
            }
            .underlined {
            text-decoration: underline;
            }
            .underlined2 {
            border-bottom: 1px solid #ccc;
            min-width: 100px;
            display: inline-block;
            margin-top: 40px;
            }
            .grayed {
            -webkit-filter: grayscale(1);
            }
            .special-ul li {
            margin-bottom: 10px;
            }
            .special-ul {
            line-height: 1.5;
            }
            ol,
            ul {
                padding-left: 20px;
            }
            .row {
            display: flex;
            }
            .column-50 {
            flex: 50%;
            }
            .column-25 {
            flex: 25%;
            }
            .column-33 {
            flex: 33%;
            }
            .boxy {
            padding: 10px;
            border: 1px solid #ccc;
            margin: 5px;
            }
            .initial {
                border-bottom: 1px solid #ccc;
                display: inline-block;
                width: 20px;
                height: 20px;
                margin-top: 40px;
            }
            .form-control {
                display: block;
                margin-top: 5px;
                margin-bottom: 10px;
                padding: 5px;
                border: 1px solid #ccc;
            }
            .no-ol ol li {
                list-style-type: none;
                text-indent: -1.2em;
            }
            .no-ol ol li .boxy {
                text-indent: 0 !important;
            }
            .ql-editor ul,
            .ql-editor.ql-snow ul,
            .ql-editor ul.ql-list {
                list-style: none !important;
                padding-left: 10px !important;
                margin-left: 0 !important;
            }
            .ql-editor ol li:not(.ql-direction-rtl), .ql-editor ul li:not(.ql-direction-rtl) {
                padding-left: 0 !important;
            }
            .ql-editor ul > li::before {
                content: '';
            }
            .ql-editor ul {
                list-style: disc;
                padding-left: 2em;
            }

            .ql-editor ul li {
                position: relative;
                padding-left: 1em;
                text-indent: -1em;
            }

            .ql-editor ul li::before {
                content: "";
                position: absolute;
                left: 0;
            }
        </style>
        </head>
    <body class="ql-editor">
`;

const styling_ertl = `
    <style>
    .underlined2,
        .underline {
            border-bottom: 1px solid #484848;
        }
        .margin-top {
            margin-top: 50px;
        }
    
        .left-margin {
            margin-left: 50px;
        }
    
        body {
            margin-right: 50px;
            font-size: 13px;
            color: #484848;
        }
    
        .center {
            margin-left: auto;
            margin-right: auto;
        }
    
        .pageFooter-first {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            padding: 1rem
        }
    
        .tab {
            margin-left: 10px;
        }
    
        .pb_before {
            page-break-before: always !important;
        }
    
        ol {
            counter-reset: list;
            padding-left: 1em;
        }
    
        table {
            border: solid #000;
            border-collapse: collapse;
            font-size: 10px;
        }
    
        table td + td {
            border-left: 2px solid #000;
            padding-left: 10px;
        }
        .page-break {
            page-break-after:always;
        }
        .text-center {
            text-align:center !important;
        }
        hr {
            border-bottom: 1px solid #ccc;
        }
        .white-text {
            color: white;
        }
        .pdfheader {
            width: 100%;
            margin: 0 auto;
        }
        .rcolumn {
            float: left;
            width: 50%;
          }
          
          /* Clear floats after the columns */
          .rrow:after {
            content: "";
            display: table;
            clear: both;
          }
          .the-table {
            padding: 20px; 
            border: 3px solid rgb(0, 0, 0);
          }
          table.the-table {
            table-layout: fixed;
          }
          .the-table th,
          .the-table td {
              padding: 15px 20px;
              width: 50%;
          }
          .border-left {
            border-left: 2px solid rgb(0, 0, 0);
          }
          .border-right {
            border-right: 2px solid rgb(0, 0, 0);
          }
          .very-small {
              font-size: 5px;
          }
          .small {
              font-size: 10px;
          }
          p {
              margin-bottom:5px;
              margin-top: 5px;
          }
          #ertl-number {
              text-align: right;
          }
          body {
                font-family: 'Open Sans', sans-serif;
                font-size: 10px;
                line-height: 1.5;
          }
          .times p,
          .times div {
                font-family: "Times New Roman", Times, serif !important;
          }
          .font-14 {
              font-size: 14px;
          }
          .font-10 {
              font-size: 10px;
          }
          .small {
              font-size: 9px;
          }
          .row {
            display: flex;
          }
          .column-50 {
            flex: 50%;
          }
          .column-25 {
            flex: 25%;
          }
          .column-33 {
            flex: 33%;
          }
    </style>
`;

const html_footer = `
        </body>
    </html>
`;

function replaceOwnerInitialsWithCount(htmlString, count = 1, masterObj) {

    let ownersHTML = "<div>OWNER INITIALS : ";
    property_owner_emails.forEach((n, i) => {
        const tab = `**${count}_${i + 1}_I**`;
        masterObj[n].initialHereTabs.push({ anchorString: tab });
        ownersHTML += `<span style="border-bottom:1px solid #ccc;width:60px;margin-right:20px">
            <span class="white-text">${tab}</span>
        </span>`;
    });
    ownersHTML += "</div>";

  let instance = 1;
  const docusignObj = {};
  const newHtml = htmlString.replace(/{{\s*owner_initials\s*}}/g, () => {
    const replacement = `**${instance}_${count}_I**`;
    instance++;
    return replacement;
  });

  return {
    docusignObj,
    newHtml
  }
}

function removeNewlines(str) {
  return str.replace(/\n/g, '');
}

const reactStyleToInlineCSS = (styleObj) => {
  return Object.entries(styleObj)
    .map(([key, value]) => {
      const kebabKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      const cssValue = typeof value === 'number' && !['z-index', 'opacity', 'flex', 'font-weight'].includes(kebabKey)
        ? `${value}px`
        : value;
      return `${kebabKey}: ${cssValue};`;
    })
    .join(' ');
}

const renderPMAPDF = (args) => {
    let html = ``;
    const { data, type, blocks, is_preview_only } = args;
    blocks.forEach(b => {
        if (
            b.type === 'Default' || 
            b.type === 'Inline' || 
            b.type === 'Page Break' ||
            b.type === 'Logo' ||
            b.type === 'Centered Logo'
        ) {
            const style_start = b.style ? `<span style="${reactStyleToInlineCSS(b.style)}">` : '';
            const style_end = b.style ? '</span>' : '';
            html += `${style_start}${b.content ? b.content : ''}${style_end}`;
        }
        if (b.type === '2 Column Table') {
            const style_start = b.style ? `<span style="${reactStyleToInlineCSS(b.style)}">` : '';
            const style_end = b.style ? '</span>' : '';
            html += `
            ${style_start}
                <center>
                    <table class="the-table">
                        <tbody>
                            <tr>
                                <td>
                                    ${b.content ? b.content : ''}
                                </td>
                                <td style="padding-left:20px">
                                    ${b.content2 ? b.content2 : ''}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </center>
            ${style_end}
            `;
        }
        if (
            b.type === 'Variable'
        ) {
            let highlight_start = '';
            let highlight_end = '';
            if (is_preview_only) {
                highlight_start = '<span style="color:green">';
                highlight_end = '</span>';
            }
            html += `${highlight_start}${b.content ? b.content : ''}${highlight_end}`;
        }
    })
    if (is_preview_only) {
        html = wrapCurlyBracesInSpan(html);
    }
    return html;
}

const wrapCurlyBracesInSpan = (htmlString) => {
  return htmlString.replace(/{{\s*(.*?)\s*}}/g, (_, variable) => {
    return `<span style="color:green">${variable}</span>`;
  });
}


const renderERTLPDF = (args) => {
    let html = ``;
    const { data, type, blocks, is_preview_only } = args;
    blocks.forEach(b => {
        if (
            b.type === 'Default' || 
            b.type === 'Inline' || 
            b.type === 'Page Break' ||
            b.type === 'Logo' ||
            b.type === 'Centered Logo'
        ) {
            const style_start = b.style ? `<span style="${reactStyleToInlineCSS(b.style)}">` : '';
            const style_end = b.style ? '</span>' : '';
            html += `${style_start}${b.content ? b.content : ''}${style_end}`;
        }
        if (b.type === '2 Column Table') {
            const style_start = b.style ? `<span style="${reactStyleToInlineCSS(b.style)}">` : '';
            const style_end = b.style ? '</span>' : '';
            html += `
            ${style_start}
                <center>
                    <table class="the-table">
                        <tbody>
                            <tr>
                                <td>
                                    ${b.content ? b.content : ''}
                                </td>
                                <td style="padding-left:20px">
                                    ${b.content2 ? b.content2 : ''}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </center>
            ${style_end}
            `;
        }
        if (
            b.type === 'Variable'
        ) {
            let highlight_start = '';
            let highlight_end = '';
            if (is_preview_only) {
                highlight_start = '<span style="color:green">';
                highlight_end = '</span>';
            }
            html += `${highlight_start}${b.content ? b.content : ''}${highlight_end}`;
        }
    })
    if (is_preview_only) {
        html = wrapCurlyBracesInSpan(html);
    }
    return html;
}

export const renderTemplatePDF = (args) => {
    const { data, type, blocks } = args;
    console.log('data', data, type, blocks);
    let html = '';

        // PMA 
    if (type === 'PMA') {
        html += html_header;
        html += renderPMAPDF(args);
        html += html_footer;
    } else if (type === 'ERTL') {   
        // ERTL
        html += html_header;
        html += styling_ertl;
        html += renderERTLPDF(args);
        html += html_footer;
    }
    html = minifyHTML(html);
    console.log('html rendered', html);
    return html;
}

export const minifyHTML = (html) => {
  return html
    .replace(/\n/g, '')                    // Remove newline characters
    .replace(/\r/g, '')                    // Remove carriage returns
    // .replace(/\t/g, '')                    // Remove tabs
    // .replace(/\s{2,}/g, ' ')               // Collapse multiple spaces
    // .replace(/>\s+</g, '><')               // Remove space between tags
    .trim();                               // Remove leading/trailing spaces
}